import { useQuery } from 'react-query'
import {
  getLookupUsage,
  LookupUsageParams,
} from 'services/cm-api/get-lookup-usage'

const TEN_MINUTES = 600_000

// One heavy count on the primary per customer and period, so a result is kept
// for a while and a failure is not retried on its own. A failure is thrown so a
// later visit asks again instead of reading it from the cache.
export function useLookupUsage(
  customerId: number | string,
  params: LookupUsageParams = {},
) {
  return useQuery(
    ['getLookupUsage', customerId, params],
    async () => {
      const response = await getLookupUsage(customerId, params)
      if (response.success === false) throw response.error
      return response.data
    },
    {
      enabled: Boolean(localStorage.getItem('FB_ACCESS_TOKEN')),
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: TEN_MINUTES,
    },
  )
}
